/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Lcd_PrintingInputs */

const tr_landing_telegram_mock_lcd_printing = /** @type {(inputs: Landing_Telegram_Mock_Lcd_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● yazdırıyor...`)
};

const en_landing_telegram_mock_lcd_printing = /** @type {(inputs: Landing_Telegram_Mock_Lcd_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● printing...`)
};

const de_landing_telegram_mock_lcd_printing = /** @type {(inputs: Landing_Telegram_Mock_Lcd_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● druckt...`)
};

const ru_landing_telegram_mock_lcd_printing = /** @type {(inputs: Landing_Telegram_Mock_Lcd_PrintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`● печатает...`)
};

/**
* | output |
* | --- |
* | "● printing..." |
*
* @param {Landing_Telegram_Mock_Lcd_PrintingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_lcd_printing = /** @type {((inputs?: Landing_Telegram_Mock_Lcd_PrintingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Lcd_PrintingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_lcd_printing(inputs)
	if (locale === "de") return de_landing_telegram_mock_lcd_printing(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_lcd_printing(inputs)
	return tr_landing_telegram_mock_lcd_printing(inputs)
});